import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubSourcesHeroHeaderCls: string;
			heHubSourcesHeroSubheaderCls: string;
			heHubSourcesHeroSectionTextFirstCls: string;
			heHubSourcesHeroSectionTextSecondCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub Sources Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubSourcesHeroHeaderCls || '', 'he_hub_sources_hero', { animCls: 'animate__zoomIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubSourcesHeroSubheaderCls || '', 'he_hub_sources_hero', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubSourcesHeroSectionTextFirstCls || '', 'he_hub_sources_hero', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubSourcesHeroSectionTextSecondCls || '', 'he_hub_sources_hero', { animCls: 'animate__fadeInLeft25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;